'use client';
import React from 'react';

export default function Footer() {
  return (
    <footer
      style={{
        backgroundColor: '#f8f9fa',
        borderTop: '1px solid #e0e0e0',
        padding: '60px 0 0',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '0 24px' }}>
        {/* Footer Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            gap: '60px',
            paddingBottom: '40px',
          }}
          className="footer-grid"
        >
          {/* Logo */}
          <div style={{ display: 'flex', alignItems: 'flex-start' }}>
            <a href="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <div style={{
                width: '52px',
                height: '52px',
                backgroundColor: '#003c82',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" fill="#6dcff6" />
                  <polyline points="9 22 9 12 15 12 15 22" fill="#ffffff" />
                </svg>
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1 }}>
                <span style={{
                  fontSize: '22px',
                  fontWeight: '700',
                  color: '#003c82',
                  letterSpacing: '-0.02em',
                }}>Brickwell</span>
                <span style={{
                  fontSize: '11px',
                  fontWeight: '500',
                  color: '#6dcff6',
                  letterSpacing: '0.12em',
                  textTransform: 'uppercase',
                }}>Housing</span>
              </div>
            </a>
          </div>

          {/* Nav */}
          <nav>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'auto 1fr auto',
                gap: '40px',
              }}
              className="footer-nav"
            >
              {/* Social Links */}
              <div>
              </div>

              {/* Main Nav Links */}
              <div>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {[
                    { label: 'About Us', href: '/about' },
                    { label: 'Portfolio', href: '/portfolio' },
                    { label: 'Expertise', href: '/expertise' },
                    { label: 'Community Impact', href: '#community' },
                    { label: 'Media Center', href: '/media-center' },
                    { label: 'Careers', href: '#careers' },
                    { label: 'Contact Us', href: '/contact' },
                  ].map((link) => (
                    <li key={link.label} style={{ marginBottom: '8px' }}>
                      <a
                        href={link.href}
                        style={{
                          color: '#333333',
                          textDecoration: 'none',
                          fontSize: '14px',
                          transition: 'color 0.2s ease',
                        }}
                        onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#003c82'; }}
                        onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#333333'; }}
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              {/* External Links */}
              {/* remove External Links div */}
            </div>
          </nav>
        </div>

        {/* Copyright */}
        <div
          style={{
            borderTop: '1px solid #e0e0e0',
            padding: '20px 0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            gap: '12px',
          }}
        >
          <p style={{ fontSize: '13px', color: '#888', margin: 0 }}>
            &copy; 2026 Brickwell Housing &ndash; All Rights Reserved
          </p>
          <ul
            style={{
              display: 'flex',
              gap: '20px',
              listStyle: 'none',
              padding: 0,
              margin: 0,
            }}
          >
            {[
              { label: 'Privacy Policy', href: '/privacy-policy' },
              { label: 'Accessibility', href: '/accessibility' },
              { label: 'Terms of Use', href: '/terms-of-use' },
            ].map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  style={{
                    fontSize: '13px',
                    color: '#888',
                    textDecoration: 'none',
                    transition: 'color 0.2s ease',
                  }}
                  onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#003c82'; }}
                  onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.color = '#888'; }}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </footer>
  );
}
